<!-- eslint-disable consistent-return -->
<!-- eslint-disable no-cond-assign -->
<!-- eslint-disable no-use-before-define -->
<!-- eslint-disable no-unused-expressions -->
<script>
import { defineComponent, ref, toRefs, computed, nextTick } from "@vue/composition-api";
import useEmialForm from "./use-emial-form";
import useEmailState from "./use-email-state";
import MessageRichArea from "../components/MessageRichArea.vue";
import RecipientMails from "../components/RecipientMails.vue";
import ApproverPhones from "../components/ApproverPhones.vue";
import { createPlanEmailApi, modifyPlanEmailApi } from "../apis/email-manage";
import { reverseConstructRichArea } from "../helper/rich-area-helper";

export default defineComponent({
  name: "EmailDrawer",
  components: { MessageRichArea, RecipientMails, ApproverPhones },
  props: {
    createdEmail: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["on-refresh-table"],
  setup(props, { refs, root, emit }) {
    const visible = ref(false);
    const isCreate = ref(true);

    const { formVariables, restFormState } = useEmialForm();
    const { messageNames, insertArguments, unwantedApproverMobile } = useEmailState();

    // 选择的邮件名称对应的可插入的参数
    const selInsertArguments = computed(() => {
      const { mailName } = formVariables.formState;
      const matchMessage = messageNames.find((item) => item.type === mailName);
      if (!matchMessage) return [];
      const insertKeys = Object.keys(insertArguments);
      return matchMessage.insertArguments.map((i) => insertKeys[i]);
    });

    const setDefaultValue = (val) => {
      let { mailContent, mailHeader } = val;
      mailContent = reverseConstructRichArea(mailContent, insertArguments);
      mailHeader = reverseConstructRichArea(mailHeader, insertArguments);

      formVariables.formState = {
        id: val.id,
        mailName: val.mailCode,
        mailDescription: val.mailDescription,
        mailHeader,
        mailContent,
        recipientAddress: JSON.parse(val.recipientAddress),
        approverPhone: JSON.parse(val.approverPhone),
      };

      refs.messageRichAreaRef.setValue(mailContent);
      refs.messageRichAreaRef2.setValue(mailHeader);
    };

    const openModal = async (val) => {
      isCreate.value = !val;
      visible.value = true;
      await nextTick();
      val && setDefaultValue(val);
    };

    const handleClose = () => {
      visible.value = false;
      restFormAndRichArea()
    };

    // 重置表单和编辑器内容
    const restFormAndRichArea = () => {
      restFormState();
      refs.formRef.resetFields()
      refs.messageRichAreaRef.rest();
      refs.messageRichAreaRef2.rest();
    }

    // 创建新邮箱
    const createProject = async () => {
      // 校验邮件配置是否>=1个，>=1个提示邮件已创建不可保存
      const { mailName } = formVariables.formState;
      if (isCreate.value && props.createdEmail.find(({ mailCode }) => mailCode === mailName)) {
        root.$message.warning("邮件已创建不可保存！");
        return;
      }

      const params = getRequestParams();
      await rquestCreateMailbox(params);
      root.$message.success(`邮件${isCreate ? "创建" : "编辑"}成功！`);
      visible.value = false;
      restFormAndRichArea();
      emit("on-refresh-table");
    };

    // 请求创建或者修改邮箱
    const rquestCreateMailbox = async (params) => {
      try {
        const typeRequest = isCreate.value ? createPlanEmailApi : modifyPlanEmailApi;
        return await typeRequest(params);
      } catch (err) {
        console.log(err);
      }
    };

    // 获取请求参数
    const getRequestParams = () => {
      const { formState } = formVariables;
      const matchMailbox = messageNames.find(({ type }) => type === formState.mailName);
      const transMailContent = extractMailboxContent(formState.mailContent);
      const transMailHeader = extractMailboxContent(formState.mailHeader);

      return {
        id: formState.id,
        mailCode: matchMailbox.type,
        mailName: matchMailbox.label,
        mailDescription: formState.mailDescription,
        mailHeader: transMailHeader,
        mailContent: transMailContent,
        recipientAddress: formState.recipientAddress,
        approverPhone: formState.approverPhone,
      };
    };

    // 提取邮件正文
    const extractMailboxContent = (mailContent) => {
      let str = mailContent.replaceAll(' class="insert-argument" contenteditable="false"', "");
      str = str.replaceAll("&nbsp;", "");
      const regex = /<span>(.*?)<\/span>/;
      let match;
      while ((match = regex.exec(str)) !== null) {
        str = str.replace(match[0], insertArguments[match[1]]);
      }
      return str;
    };

    // 提交表单数据
    const handleSubmit = () => {
      refs.formRef.validate((valid) => {
        if (valid) {
          createProject();
        } else {
          return false;
        }
      });
    };

    // 邮件名称切换事件
    const handelChangeMailName = () => {
      const backMailName = formVariables.formState.mailName
      refs.messageRichAreaRef.rest();
      refs.messageRichAreaRef2.rest();
      restFormState()
      formVariables.formState.mailName = backMailName
    };

    // 对表单部分字段进行校验
    const validateForm = (type) => {
      console.log(type)
      refs.formRef.validateField(type);
    };

    // 邮件名称关键字查询
    const nameFilterOption = (input, option) =>
      option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return {
      visible,
      isCreate,
      selInsertArguments,
      unwantedApproverMobile,
      openModal,
      handleClose,
      handleSubmit,
      validateForm,
      messageNames,
      nameFilterOption,
      handelChangeMailName,
      ...toRefs(formVariables),
    };
  },
});
</script>

<template>
  <a-drawer
    :title="`${isCreate ? '新增' : '编辑'}邮件`"
    placement="right"
    :width="640"
    :visible="visible"
    @close="handleClose"
  >
    <a-form-model ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <a-form-model-item label="邮件名称" prop="mailName">
        <a-select
          v-model="formState.mailName"
          show-search
          :filter-option="nameFilterOption"
          placeholder="请选择邮件"
          @change="handelChangeMailName"
        >
          <a-select-option v-for="item in messageNames" :key="item.type" :value="item.type">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="邮件描述" prop="mailDescription">
        <a-input
          v-model="formState.mailDescription"
          placeholder="请输入邮件描述，触发场景等"
          @change="validateForm('mailDescription')"
        />
      </a-form-model-item>
      <a-form-model-item label="邮件标题" prop="mailHeader">
        <MessageRichArea
          ref="messageRichAreaRef2"
          v-model="formState.mailHeader"
          :height="40"
          :insert-arguments="selInsertArguments"
          @on-change-model-value="validateForm('mailHeader')"
        />
      </a-form-model-item>
      <a-form-model-item label="邮件内容正文" prop="mailContent">
        <MessageRichArea
          ref="messageRichAreaRef"
          v-model="formState.mailContent"
          :insert-arguments="selInsertArguments"
          @on-change-model-value="validateForm('mailContent')"
        />
      </a-form-model-item>
      <a-form-model-item label="收件人邮件" prop="recipientAddress">
        <RecipientMails
          v-model="formState.recipientAddress"
          @on-change-input="validateForm('recipientAddress')"
        />
      </a-form-model-item>
      <a-form-model-item
        v-if="!formState.mailName || unwantedApproverMobile.includes(formState.mailName)"
        label="审批人手机号"
        prop="approverPhone"
      >
        <ApproverPhones
          v-model="formState.approverPhone"
          @on-change-input="validateForm('approverPhone')"
        />
      </a-form-model-item>
      <a-form-model-item>
        <div class="operation-group">
          <a-button @click="handleClose">
            取消
          </a-button>
          <a-button type="primary" style="margin-left: 12px;" @click="handleSubmit">
            保存
          </a-button>
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<style lang="less" scoped>
.operation-group {
  text-align: right;
}
</style>
